// import React, { createContext, useContext, useEffect, useState } from "react";
// import ApiService from "services/ApiService";
// import { repeatEffect, settingsConfig } from "utils/commonFunc";
// import { useTranslation } from 'react-i18next';

// const TrafficTotalContext = createContext(null);

// // export function SwItsBisCntTotalProvider({ children }) {
// //   const [currentData, setCurrentData] = useState();

// //   useEffect(() => {
// //     return repeatEffect(async () => {
// //       const response = await ApiService.get("newdashboard/busoprt/GetBusCnt");
// //       if (response.status === 200) {
// //         const data = response.data;
// //         setCurrentData({
// //           updateTime: data.updateTime,
// //           runBusValue: data.total[0].totalVehRunCnt, // 운행중 버스
// //           totalBusValue: data.total[0].totalVehCnt, // 전체 버스
// //           totalRouteCnt: data.total[0].totalRouteCnt, // 전체 노선 수
// //           totalStationCnt: data.total[0].totalStationCnt, // 전체 정류장
// //           totalBitCnt: data.total[0].totalBitCnt, // 전체 BIT 숫자
// //           bitStatConnect: data.bitstat[0].statCnt, // 전체 BIT 숫자 (연결 o)
// //           bitStatDisConnect: data.bitstat[1].statCnt, // 전체 BIT 숫자 (연결 x)
// //           infoTotal: data.rows,
// //         });
// //       }
// //     }, settingsConfig().contentUpdateDelaySec);
// //   }, []);

// //   return (
// //     <TrafficTotalContext.Provider value={currentData}>
// //       {children}
// //     </TrafficTotalContext.Provider>
// //   );
// // }

// export function SwItsBisCntTotalProvider({ children }) {
//   const [currentData, setCurrentData] = useState();
//   const [drtData, setDrtData] = useState(null);

//   // 기존 버스 데이터 가져오기
//   useEffect(() => {
//     return repeatEffect(async () => {
//       const response = await ApiService.get("newdashboard/busoprt/GetBusCnt");
//       if (response.status === 200) {
//         const data = response.data;
//         setCurrentData({
//           updateTime: data.updateTime,
//           runBusValue: data.total[0].totalVehRunCnt,
//           totalBusValue: data.total[0].totalVehCnt,
//           totalRouteCnt: data.total[0].totalRouteCnt,
//           totalStationCnt: data.total[0].totalStationCnt,
//           totalBitCnt: data.total[0].totalBitCnt,
//           bitStatConnect: data.bitstat[0].statCnt,
//           bitStatDisConnect: data.bitstat[1].statCnt,
//           infoTotal: data.rows,
//         });
//       }
//     }, settingsConfig().contentUpdateDelaySec);
//   }, []);

//   // DRT 데이터 별도로 가져오기
//   useEffect(() => {
//     return repeatEffect(async () => {
//       const response = await ApiService.get("newdashboard/busoprt/GetDrt");
//       if (response.status === 200) {
//         setDrtData(response.data[0].drtCnt);  // .drtCnt 추가!
//       }
//     }, settingsConfig().contentUpdateDelaySec);
//   }, []);

//    const updateDrtCount = async (newCount) => {
//     try {
//       const response = await ApiService.post(`newdashboard/busoprt/UpdtDrt?cnt=${newCount}`);
//       if (response.status === 200) {
//         setDrtData(newCount);
//         return true;
//       }
//       return false;
//     } catch (error) {
//       console.error('DRT 업데이트 실패:', error);
//       return false;
//     }
//   };

//   // currentData와 drtData를 합쳐서 제공
//   const mergedData = currentData && {
//     ...currentData,
//     drtCnt: drtData || 0,
//   };

//   return (
//     <TrafficTotalContext.Provider value={mergedData}>
//       {children}
//     </TrafficTotalContext.Provider>
//   );
// }

// // export function SwItsBisCntTotalInfo() {
// //   const currentData = useContext(TrafficTotalContext);
// //   if (!currentData) return null;


// //   return (
// //     <div className="flx flx_col a_center j_center">
// //       <div className="flx a_flx_end">
// //         <span className="subTxt" style={{ marginRight: '10px' }}>
// //           운행중
// //         </span>
// //         <span className="nbr" style={{ fontWeight: "var(--ft-Bold)" }}>
// //           {currentData.runBusValue.toLocaleString()}
// //         </span>
// //         <span
// //           className="subTxt"
// //           style={{ marginLeft: "18px", marginBottom: "14px" }}
// //         >
// //           대
// //         </span>
// //         <span className="subTxt sls" style={{ marginBottom: '10px' }}>|</span>
// //         <span
// //           className="subTxt"
// //           style={{ marginRight: "18px", marginBottom: "14px" }}
// //         >
// //           총
// //         </span>
// //         <span className="nbr" style={{ fontWeight: "var(--ft-Bold)" }}>
// //           {(currentData.totalBusValue + 10).toLocaleString()}
// //         </span>
// //         <span
// //           className="subTxt"
// //           style={{ marginLeft: "18px", marginBottom: "14px" }}
// //         >
// //           대
// //         </span>
// //       </div>
// //     </div>
// //   );
// // }

// // const BUS_TYPE_LABELS = {
// //   13: "시내",
// //   14: "광역",
// //   30: "마을",
// //   50: "DRT",
// // };

// // const ORDER = [14, 13, 30, 50];

// // const BUS_TYPE_CLASSES = {
// //   14: "red",   // 광역
// //   13: "gr",    // 시내
// //   30: "ylw",   // 마을
// //   50: "blue"     // DRT는 임의로 시내와 동일 색(gr) 지정 (필요하면 따로 설정)
// // };

// // export function SwItsBisCntInfo({ title, detail = false }) {
// //   const currentData = useContext(TrafficTotalContext);
// //   if (!currentData) return null;

// //   let field = "vehCnt";
// //   let unit = "대";

// //   if (title === "route") {
// //     field = "routeCnt";
// //     unit = "개";
// //   } else if (title === "station") {
// //     field = "stationCnt";
// //     unit = "개소";
// //   }
// //   if (detail) {
// //     let busDetailData = [];

// //     if (title === "bus") {
// //       const baseTypes = [13, 14, 30, 50];

// //       const rawData = currentData.infoTotal
// //         .filter((item) => baseTypes.includes(item.type));

// //       const typeMap = Object.fromEntries(
// //         baseTypes.map((type) => [type, { type, [field]: 10 }])
// //       );

// //       rawData.forEach((item) => {
// //         typeMap[item.type] = item;
// //       });

// //       busDetailData = Object.values(typeMap);
// //     } else if (title === "route") {
// //       busDetailData = currentData.infoTotal
// //         .filter((item) => [13, 14, 30].includes(item.type));
// //     }

// //     busDetailData = busDetailData
// //       .sort((a, b) => ORDER.indexOf(a.type) - ORDER.indexOf(b.type))
// //       .map((item) => ({
// //         label: BUS_TYPE_LABELS[item.type],
// //         value: item[field],
// //         className: BUS_TYPE_CLASSES[item.type] || "gr",
// //       }));

// //     return (
// //       <div className="subBox flx flx_col j_spc_btw">
// //         {busDetailData.map((item, idx) => (
// //           <div key={idx} className="subBoxLi flx a_center j_spc_btw">
// //             <span>{item.label}</span>
// //             <div className="flx a_flx_end">
// //               <span className={`${item.className} fgr`}>
// //                 {item.value?.toLocaleString()}
// //               </span>
// //               <span className="unit" style={{marginBottom:'6px', fontSize:'var(--ft-24)'}}>{unit}</span>
// //             </div>
// //           </div>
// //         ))}
// //       </div>
// //     );
// //   }
// //   else {
// //     let cnt = null;
// //     if (title === "bus") {
// //       cnt = (currentData.totalBusValue + 10).toLocaleString();
// //     } else if (title === "route") {
// //       cnt = currentData.totalRouteCnt.toLocaleString();
// //     } else if (title === "station") {
// //       cnt = currentData.totalStationCnt.toLocaleString();
// //     } else if (title === "bit") {
// //       cnt = currentData.totalBitCnt.toLocaleString();
// //     }

// //     return (
// //       <div>
// //         <div className="flx a_flx_end j_cetner">
// //           <span className="fgr">{cnt}</span>
// //           <span className="unit" style={{ marginBottom: "12px" }}>
// //             {unit}
// //           </span>
// //         </div>
// //       </div>
// //     );
// //   }
// // }

// // export function SwItsRunBisCntDetailInfo() {
// //   const currentData = useContext(TrafficTotalContext);
// //   const { t, i18n } = useTranslation(); 

// //   if (!currentData || !currentData.infoTotal) return null;
// //   const BUS_TYPE_COLOR_CLASSES = {
// //     14: "red",   // 광역
// //     13: "gr",    // 시내
// //     30: "ylw",   // 마을
// //     50: "white"  // DRT (사용하지 않지만 예비로 설정)
// //   };

// //   const busTypeData = currentData.infoTotal
// //     .filter((item) => [13, 14, 30].includes(item.type))
// //     .sort((a, b) => ORDER.indexOf(a.type) - ORDER.indexOf(b.type))
// //     .map((item) => ({
// //       label: BUS_TYPE_LABELS[item.type],
// //       runCount: item.vehRunCnt,
// //       className: BUS_TYPE_COLOR_CLASSES[item.type] || "gr"
// //       //    lastMonthAvg: 100,
// //     }));

// //   const totalRunCount = currentData.runBusValue || 0;

// //   return (
// //     <div className="L_2m inner">
// //       <div className="titWrap flx j_spc_btw">
// //         {/* <h2 className="boxTit" style={{color:'var(--iv-09)'}}>버스운행</h2> */}
// //         <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{color:'var(--iv-09)'}}>{t('OperationStatus')}
// //         </h2>
// //       </div>
// //       <div className="busConts flx">
// //         <div className="left innerBg flx flx_col a_center j_center">
// //           <p className="subTit">운행중</p>
// //           <div className="flx a_flx_end j_center">
// //             <span className="nbr">{totalRunCount.toLocaleString()}</span>
// //             <span className="subTxt">대</span>
// //           </div>
// //         </div>
// //         <div className="right grid flx flx_col j_spc_btw">
// //           {busTypeData.map((bus) => (
// //             <div
// //               key={bus.label}
// //               className='gridLi flx a_center j_spc_btw'
// //               style={{ borderRadius: "32px" }}
// //             >
// //               <span className='grpTit'>{bus.label}</span>
// //               <div
// //                 className="flx a_flx_end j_flx_end"
// //                 style={{ width: "200px" }}
// //               >
// //                 <span
// //                   className={`${bus.className} fgr`}
// //                 >
// //                   {bus.runCount?.toLocaleString()}
// //                 </span>
// //                 <span
// //                   className="unit"
// //                   style={{ marginBottom: "14px", marginLeft: "10px" }}
// //                 >
// //                   대
// //                 </span>
// //               </div>
// //             </div>
// //           ))}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }


// // export function SwItsBisCntInfoModule() {
// //   const currentData = useContext(TrafficTotalContext);
// //   if (!currentData) return null;

// //   return (
// //     <div className="flx flx_col a_center j_center">
// //       <div className="flx a_flx_end">
// //         {/* <span className="subTxt" style={{marginRight:'10px'}}>
// //             운행중
// //           </span> */}
// //         <span className="nbr" style={{ fontWeight: "var(--ft-Bold)" }}>
// //           {currentData.runBusValue.toLocaleString()}
// //         </span>
// //         <span
// //           className="subTxt"
// //           style={{ marginLeft: "18px", marginBottom: "14px" }}
// //         >
// //           대
// //         </span>
// //       </div>
// //     </div>
// //   );
// // }

// export function SwItsBisCntTotalInfo() {
//   const currentData = useContext(TrafficTotalContext);
//   if (!currentData) return null;

//   return (
//     <div className="flx flx_col a_center j_center">
//       <div className="flx a_flx_end">
//         <span className="subTxt" style={{ marginRight: '10px' }}>
//           운행중
//         </span>
//         <span className="nbr" style={{ fontWeight: "var(--ft-Bold)" }}>
//           {currentData.runBusValue.toLocaleString()}
//         </span>
//         <span
//           className="subTxt"
//           style={{ marginLeft: "18px", marginBottom: "14px" }}
//         >
//           대
//         </span>
//         <span className="subTxt sls" style={{ marginBottom: '10px' }}>|</span>
//         <span
//           className="subTxt"
//           style={{ marginRight: "18px", marginBottom: "14px" }}
//         >
//           총
//         </span>
//         <span className="nbr" style={{ fontWeight: "var(--ft-Bold)" }}>
//           {(currentData.totalBusValue + currentData.drtCnt).toLocaleString()}
//         </span>
//         <span
//           className="subTxt"
//           style={{ marginLeft: "18px", marginBottom: "14px" }}
//         >
//           대
//         </span>
//       </div>
//     </div>
//   );
// }

// const BUS_TYPE_LABELS = {
//   13: "시내",
//   14: "광역",
//   30: "마을",
//   50: "DRT",
// };

// const ORDER = [14, 13, 30, 50];

// const BUS_TYPE_CLASSES = {
//   14: "red",
//   13: "gr",
//   30: "ylw",
//   50: "blue"
// };

// export function SwItsBisCntInfo({ title, detail = false }) {
//   const currentData = useContext(TrafficTotalContext);
//   if (!currentData) return null;

//   let field = "vehCnt";
//   let unit = "대";

//   if (title === "route") {
//     field = "routeCnt";
//     unit = "개";
//   } else if (title === "station") {
//     field = "stationCnt";
//     unit = "개소";
//   }

//   if (detail) {
//     let busDetailData = [];

//     if (title === "bus") {
//       const baseTypes = [13, 14, 30];

//       const rawData = currentData.infoTotal
//         .filter((item) => baseTypes.includes(item.type));

//       const typeMap = Object.fromEntries(
//         baseTypes.map((type) => [type, { type, [field]: 0 }])
//       );

//       rawData.forEach((item) => {
//         typeMap[item.type] = item;
//       });

//       // DRT 데이터 별도 추가
//       busDetailData = [
//         ...Object.values(typeMap),
//         { type: 50, [field]: currentData.drtCnt || 0 }
//       ];
//     } else if (title === "route") {
//       busDetailData = currentData.infoTotal
//         .filter((item) => [13, 14, 30].includes(item.type));
//     }

//     busDetailData = busDetailData
//       .sort((a, b) => ORDER.indexOf(a.type) - ORDER.indexOf(b.type))
//       .map((item) => ({
//         label: BUS_TYPE_LABELS[item.type],
//         value: item[field],
//         className: BUS_TYPE_CLASSES[item.type] || "gr",
//       }));

//     return (
//       <div className="subBox flx flx_col j_spc_btw">
//         {busDetailData.map((item, idx) => (
//           <div key={idx} className="subBoxLi flx a_center j_spc_btw">
//             <span>{item.label}</span>
//             <div className="flx a_flx_end">
//               <span className={`${item.className} fgr`}>
//                 {item.value?.toLocaleString()}
//               </span>
//               <span className="unit" style={{ marginBottom: '6px', fontSize: 'var(--ft-24)' }}>{unit}</span>
//             </div>
//           </div>
//         ))}
//       </div>
//     );
//   }
//   else {
//     let cnt = null;
//     if (title === "bus") {
//       cnt = (currentData.totalBusValue + currentData.drtCnt).toLocaleString();
//     } else if (title === "route") {
//       cnt = currentData.totalRouteCnt.toLocaleString();
//     } else if (title === "station") {
//       cnt = currentData.totalStationCnt.toLocaleString();
//     } else if (title === "bit") {
//       cnt = currentData.totalBitCnt.toLocaleString();
//     }

//     return (
//       <div>
//         <div className="flx a_flx_end j_cetner">
//           <span className="fgr">{cnt}</span>
//           <span className="unit" style={{ marginBottom: "12px" }}>
//             {unit}
//           </span>
//         </div>
//       </div>
//     );
//   }
// }

// export function SwItsRunBisCntDetailInfo() {
//   const currentData = useContext(TrafficTotalContext);
//   const { t, i18n } = useTranslation();

//   if (!currentData || !currentData.infoTotal) return null;
//   const BUS_TYPE_COLOR_CLASSES = {
//     14: "red",
//     13: "gr",
//     30: "ylw",
//     50: "white"
//   };

//   const busTypeData = currentData.infoTotal
//     .filter((item) => [13, 14, 30].includes(item.type))
//     .sort((a, b) => ORDER.indexOf(a.type) - ORDER.indexOf(b.type))
//     .map((item) => ({
//       label: BUS_TYPE_LABELS[item.type],
//       runCount: item.vehRunCnt,
//       className: BUS_TYPE_COLOR_CLASSES[item.type] || "gr"
//     }));

//   const totalRunCount = currentData.runBusValue || 0;

//   return (
//     <div className="L_2m inner">
//       <div className="titWrap flx j_spc_btw">
//         <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-09)' }}>{t('OperationStatus')}
//         </h2>
//       </div>
//       <div className="busConts flx">
//         <div className="left innerBg flx flx_col a_center j_center">
//           <p className="subTit">운행중</p>
//           <div className="flx a_flx_end j_center">
//             <span className="nbr">{totalRunCount.toLocaleString()}</span>
//             <span className="subTxt">대</span>
//           </div>
//         </div>
//         <div className="right grid flx flx_col j_spc_btw">
//           {busTypeData.map((bus) => (
//             <div
//               key={bus.label}
//               className='gridLi flx a_center j_spc_btw'
//               style={{ borderRadius: "32px" }}
//             >
//               <span className='grpTit'>{bus.label}</span>
//               <div
//                 className="flx a_flx_end j_flx_end"
//                 style={{ width: "200px" }}
//               >
//                 <span
//                   className={`${bus.className} fgr`}
//                 >
//                   {bus.runCount?.toLocaleString()}
//                 </span>
//                 <span
//                   className="unit"
//                   style={{ marginBottom: "14px", marginLeft: "10px" }}
//                 >
//                   대
//                 </span>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

// export function SwItsBisCntInfoModule() {
//   const currentData = useContext(TrafficTotalContext);
//   if (!currentData) return null;

//   return (
//     <div className="flx flx_col a_center j_center">
//       <div className="flx a_flx_end">
//         <span className="nbr" style={{ fontWeight: "var(--ft-Bold)" }}>
//           {currentData.runBusValue.toLocaleString()}
//         </span>
//         <span
//           className="subTxt"
//           style={{ marginLeft: "18px", marginBottom: "14px" }}
//         >
//           대
//         </span>
//       </div>
//     </div>
//   );
// }


import React, { createContext, useContext, useEffect, useState } from "react";
import ApiService from "services/ApiService";
import { repeatEffect, settingsConfig } from "utils/commonFunc";
import { useTranslation } from 'react-i18next';

const TrafficTotalContext = createContext(null);

export function SwItsBisCntTotalProvider({ children }) {
  const [currentData, setCurrentData] = useState();
  const [drtData, setDrtData] = useState(null);

  // 기존 버스 데이터 가져오기
  useEffect(() => {
    return repeatEffect(async () => {
      const response = await ApiService.get("newdashboard/busoprt/GetBusCnt");
      if (response.status === 200) {
        const data = response.data;
        setCurrentData({
          updateTime: data.updateTime,
          runBusValue: data.total[0].totalVehRunCnt,
          totalBusValue: data.total[0].totalVehCnt,
          totalRouteCnt: data.total[0].totalRouteCnt,
          totalStationCnt: data.total[0].totalStationCnt,
          totalBitCnt: data.total[0].totalBitCnt,
          bitStatConnect: data.bitstat[0].statCnt,
          bitStatDisConnect: data.bitstat[1].statCnt,
          infoTotal: data.rows,
        });
      }
    }, settingsConfig().contentUpdateDelaySec);
  }, []);

  // DRT 데이터 별도로 가져오기
  useEffect(() => {
    return repeatEffect(async () => {
      const response = await ApiService.get("newdashboard/busoprt/GetDrt");
      if (response.status === 200) {
        setDrtData(response.data[0].drtCnt);
      }
    }, settingsConfig().contentUpdateDelaySec);
  }, []);

  // DRT 업데이트 함수
  const updateDrtCount = async (newCount) => {
    try {
      const response = await ApiService.post(`newdashboard/busoprt/UpdtDrt?cnt=${newCount}`);
      if (response.status === 200) {
        setDrtData(newCount);
        return true;
      }
      return false;
    } catch (error) {
      console.error('DRT 업데이트 실패:', error);
      return false;
    }
  };

  // currentData와 drtData를 합쳐서 제공
  const mergedData = currentData && {
    ...currentData,
    drtCnt: drtData || 0,
    updateDrtCount, // 업데이트 함수도 함께 제공
  };

  return (
    <TrafficTotalContext.Provider value={mergedData}>
      {children}
    </TrafficTotalContext.Provider>
  );
}

// DRT 수정 모달 컴포넌트
function DrtEditModal({ isOpen, onClose, currentCount, onUpdate }) {
  const [inputValue, setInputValue] = useState(currentCount);

  useEffect(() => {
    setInputValue(currentCount);
  }, [currentCount]);

  const handleSave = async () => {
    const result = await onUpdate(Number(inputValue));
    if (result) {
      onClose();
    } else {
      alert('DRT 수정에 실패했습니다.');
    }
  };

  if (!isOpen) return null;

  return (
      <div 
        className="drtEditBox"
        onClick={(e) => e.stopPropagation()}
      >
        {/* <div className= "boxTit">DRT 수정</div> */}
        <div className="boxConts">
          <input
            className="drtEditInput"
            type="number"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
          대
        </div>
        <div className="drtBtnWrap">
          <button className="btn" onClick={onClose}>
            취소
          </button>
          <button
            onClick={handleSave}
            className="btn"
          >
            저장
          </button>
        </div>
    </div>
  );
}

export function SwItsBisCntTotalInfo() {
  const currentData = useContext(TrafficTotalContext);
  if (!currentData) return null;

  return (
    <div className="flx flx_col a_center j_center">
      <div className="flx a_flx_end">
        <span className="subTxt" style={{ marginRight: '10px' }}>
          운행중
        </span>
        <span className="nbr" style={{ fontWeight: "var(--ft-Bold)" }}>
          {currentData.runBusValue.toLocaleString()}
        </span>
        <span
          className="subTxt"
          style={{ marginLeft: "18px", marginBottom: "14px" }}
        >
          대
        </span>
        <span className="subTxt sls" style={{ marginBottom: '10px' }}>|</span>
        <span
          className="subTxt"
          style={{ marginRight: "18px", marginBottom: "14px" }}
        >
          총
        </span>
        <span className="nbr" style={{ fontWeight: "var(--ft-Bold)" }}>
          {(currentData.totalBusValue + currentData.drtCnt).toLocaleString()}
        </span>
        <span
          className="subTxt"
          style={{ marginLeft: "18px", marginBottom: "14px" }}
        >
          대
        </span>
      </div>
    </div>
  );
}

const BUS_TYPE_LABELS = {
  13: "시내",
  14: "광역",
  30: "마을",
  50: "DRT",
};

const ORDER = [14, 13, 30, 50];

const BUS_TYPE_CLASSES = {
  14: "red",
  13: "gr",
  30: "ylw",
  50: "blue"
};

export function SwItsBisCntInfo({ title, detail = false }) {
  const currentData = useContext(TrafficTotalContext);
  const [isDrtModalOpen, setIsDrtModalOpen] = useState(false);

  if (!currentData) return null;

  let field = "vehCnt";
  let unit = "대";

  if (title === "route") {
    field = "routeCnt";
    unit = "개";
  } else if (title === "station") {
    field = "stationCnt";
    unit = "개소";
  }

  if (detail) {
    let busDetailData = [];

    if (title === "bus") {
      const baseTypes = [13, 14, 30];

      const rawData = currentData.infoTotal
        .filter((item) => baseTypes.includes(item.type));

      const typeMap = Object.fromEntries(
        baseTypes.map((type) => [type, { type, [field]: 0 }])
      );

      rawData.forEach((item) => {
        typeMap[item.type] = item;
      });

      // DRT 데이터 별도 추가
      busDetailData = [
        ...Object.values(typeMap),
        { type: 50, [field]: currentData.drtCnt || 0 }
      ];
    } else if (title === "route") {
      busDetailData = currentData.infoTotal
        .filter((item) => [13, 14, 30].includes(item.type));
    }

    busDetailData = busDetailData
      .sort((a, b) => ORDER.indexOf(a.type) - ORDER.indexOf(b.type))
      .map((item) => ({
        label: BUS_TYPE_LABELS[item.type],
        value: item[field],
        className: BUS_TYPE_CLASSES[item.type] || "gr",
        type: item.type,
      }));

    return (
      <>
        <div className="subBox flx flx_col j_spc_btw">
          {busDetailData.map((item) => (
            <div 
              key={item.label} 
              className="subBoxLi flx a_center j_spc_btw"
              onClick={() => item.type === 50 && setIsDrtModalOpen(true)}
              style={{ cursor: item.type === 50 ? 'pointer' : 'default' }}
            >
              <span>{item.label}</span>
              <div className="flx a_flx_end">
                <span className={`${item.className} fgr`}>
                  {item.value?.toLocaleString()}
                </span>
                <span className="unit" style={{ marginBottom: '6px', fontSize: 'var(--ft-24)' }}>{unit}</span>
              </div>
            </div>
          ))}
          <DrtEditModal
            isOpen={isDrtModalOpen}
            onClose={() => setIsDrtModalOpen(false)}
            currentCount={currentData.drtCnt}
            onUpdate={currentData.updateDrtCount}
          />
        </div>
      </>
    );
  }
  else {
    let cnt = null;
    if (title === "bus") {
      cnt = (currentData.totalBusValue + currentData.drtCnt).toLocaleString();
    } else if (title === "route") {
      cnt = currentData.totalRouteCnt.toLocaleString();
    } else if (title === "station") {
      cnt = currentData.totalStationCnt.toLocaleString();
    } else if (title === "bit") {
      cnt = currentData.totalBitCnt.toLocaleString();
    }

    return (
      <div>
        <div className="flx a_flx_end j_cetner">
          <span className="fgr">{cnt}</span>
          <span className="unit" style={{ marginBottom: "12px" }}>
            {unit}
          </span>
        </div>
      </div>
    );
  }
}

export function SwItsRunBisCntDetailInfo() {
  const currentData = useContext(TrafficTotalContext);
  const { t, i18n } = useTranslation();

  if (!currentData || !currentData.infoTotal) return null;
  const BUS_TYPE_COLOR_CLASSES = {
    14: "red",
    13: "gr",
    30: "ylw",
    50: "white"
  };

  const busTypeData = currentData.infoTotal
    .filter((item) => [13, 14, 30].includes(item.type))
    .sort((a, b) => ORDER.indexOf(a.type) - ORDER.indexOf(b.type))
    .map((item) => ({
      label: BUS_TYPE_LABELS[item.type],
      runCount: item.vehRunCnt,
      className: BUS_TYPE_COLOR_CLASSES[item.type] || "gr"
    }));

  const totalRunCount = currentData.runBusValue || 0;

  return (
    <div className="L_2m inner">
      <div className="titWrap flx j_spc_btw">
        <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-09)' }}>{t('OperationStatus')}
        </h2>
      </div>
      <div className="busConts flx">
        <div className="left innerBg flx flx_col a_center j_center">
          <p className="subTit">운행중</p>
          <div className="flx a_flx_end j_center">
            <span className="nbr">{totalRunCount.toLocaleString()}</span>
            <span className="subTxt">대</span>
          </div>
        </div>
        <div className="right grid flx flx_col j_spc_btw">
          {busTypeData.map((bus) => (
            <div
              key={bus.label}
              className='gridLi flx a_center j_spc_btw'
              style={{ borderRadius: "32px" }}
            >
              <span className='grpTit'>{bus.label}</span>
              <div
                className="flx a_flx_end j_flx_end"
                style={{ width: "200px" }}
              >
                <span
                  className={`${bus.className} fgr`}
                >
                  {bus.runCount?.toLocaleString()}
                </span>
                <span
                  className="unit"
                  style={{ marginBottom: "14px", marginLeft: "10px" }}
                >
                  대
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export function SwItsBisCntInfoModule() {
  const currentData = useContext(TrafficTotalContext);
  if (!currentData) return null;

  return (
    <div className="flx flx_col a_center j_center">
      <div className="flx a_flx_end">
        <span className="nbr" style={{ fontWeight: "var(--ft-Bold)" }}>
          {currentData.runBusValue.toLocaleString()}
        </span>
        <span
          className="subTxt"
          style={{ marginLeft: "18px", marginBottom: "14px" }}
        >
          대
        </span>
      </div>
    </div>
  );
}